<template>

  <el-dialog class="auth-modal" @click.self="$emit('close')" v-model="visible" width="30%">
    <div class="modal-content">
      <!-- 标题切换 -->
      <div class="modal-header">
        <h2 @click="switchTab('login')" :class="{ active: activeTab === 'login' }">用户登录</h2>
        <h2 @click="switchTab('register')" :class="{ active: activeTab === 'register' }">注册账号</h2>
      </div>

      <!-- 登录表单 -->
      <form v-if="activeTab === 'login'" @submit.prevent="handleLogin" >
        <!-- 手机号 -->
        <div class="form-group" style="margin-top: 20px">
          <input
              type="tel"
              id="phone"
              maxlength="11"
              placeholder="请输入手机号"
              v-model="loginForm.username"
              @input="validatePhone"
          />
          <div v-if="phoneError" class="error-message">{{ phoneError }}</div>
        </div>
        <!-- 登录密码 -->
        <div class="form-group">
          <input
              type="password"
              id="password"
              placeholder="登录密码"
              v-model="loginForm.password"
              @input="validatePassword"
          />
          <div v-if="passwordError" class="error-message">{{ passwordError }}</div>
        </div>
        <!-- 图片验证码 -->
        <div class="form-group" style="display: flex;justify-content: space-between;">
          <input
              type="text"
              placeholder="验证码"
              v-model="loginForm.code"
          />
          <span class="captcha" @click="getImage">
            <img :src="registerForm.captcha" alt="" style="width: 100%">
          </span>
        </div>
        <!-- 登录按钮 -->
        <div class="form-group">
          <button
              type="submit"
              :disabled="!loginForm.username || !loginForm.password  || !loginForm.code"
              :class="{ 'btn-disabled': !loginForm.username || !loginForm.password || !loginForm.code }"
          >登录</button>
        </div>
      </form>

      <!-- 注册表单 -->
      <form v-if="activeTab === 'register'" @submit.prevent="handleRegister" >
        <div class="form-group" style="margin-top: 20px">
          <el-radio-group v-model="registerForm.userFlag">
            <el-radio value="2">普通用户</el-radio>
            <el-radio value="1">评委</el-radio>
          </el-radio-group>

        </div>
        <!-- 注册手机号 -->
        <div class="form-group" style="margin-top: 20px">
          <input
              type="tel"
              maxlength="11"
              id="phone"
              placeholder="请输入手机号"
              v-model="registerForm.phoneNumber"
              @input="validatePhoneRegister"
          />
          <div v-if="phoneError" class="error-message">{{ phoneError }}</div>
        </div>
        <!--  设置登录密码  -->
        <div class="form-group">
          <input
              type="password"
              id="password"
              placeholder="请设置登录密码，不少于8位数"
              v-model="registerForm.password"
              @input="validatePasswordRegister"
          />
          <div v-if="passwordError" class="error-message">{{ passwordError }}</div>

        </div>
        <!-- 验证登录密码是否与第一次一样 -->
        <div class="form-group">
          <input
              type="password"
              id="password"
              placeholder="请确认登录密码"
              v-model="registerForm.confirmPassword"
              @input="validatePassword2"
          />
          <div v-if="passwordError2" class="error-message">{{ passwordError2 }}</div>
        </div>

        <div class="form-group" style="display: flex;justify-content: space-between;">
          <input
              type="text"
              placeholder="请输入验证码"
              v-model="registerForm.code"
          />
          <span class="captcha" @click="getImage">
            <img :src="registerForm.captcha" alt="" style="width: 100%">
          </span>
        </div>
        <div class="form-group">
          <button
              type="submit"
              :disabled="!registerForm.phoneNumber || !registerForm.password || !registerForm.confirmPassword || !registerForm.code"
              :class="{ 'btn-disabled': !registerForm.phoneNumber || !registerForm.password || !registerForm.confirmPassword || !registerForm.code }"
          >立即注册</button>
        </div>
      </form>
      <!-- 技术支持 -->
      <div class="footer">
        <p>技术支持：13552946354</p>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import {ref, reactive, onMounted} from 'vue';
import * as homeApi from "@/api/home"
import {useAuthStore} from "@/stores/authStore";
import {ElMessage} from "element-plus";
// 1. 定义 props 和 emits (如果使用 v-model)
// eslint-disable-next-line no-undef
const emit = defineEmits(['close', 'login-success','update:visible']);
// eslint-disable-next-line no-undef,no-unused-vars
const props = defineProps({
  visible: Boolean
})

const authData = reactive({
  token: '',
  userFlag:'',
  userInfo: null,
})
// eslint-disable-next-line no-undef
const visible = defineModel('visible', { type: Boolean, default: false }) // 双向绑定

// 获取 user store 实例
const authStore = useAuthStore()
// 响应式数据
const activeTab = ref('login');
const uuid = ref('')

// 登录表单数据
const loginForm = reactive({
  username: '',
  password: '',
  code: '',
  uuid:''
});

// 注册表单数据
const registerForm = reactive({
  phoneNumber: '',
  password: '',
  confirmPassword:'',
  userFlag: '',
  code:'',
  captcha:''

});

// 错误信息
const phoneError = ref('');
const passwordError = ref('');
const passwordError2 = ref('');

// 切换标签页
const switchTab = (tab) => {
  activeTab.value = tab;
};

// 验证规则
const validatePhone = () => {
  const phoneRegex = /^1[3-9]\d{9}$/;
  if (!loginForm.username) {
    phoneError.value = '手机号不能为空';
    return false;
  }
  if (!phoneRegex.test(loginForm.username)) {
    phoneError.value = '手机号格式不正确';
    return false;
  }
  phoneError.value = '';
  return true;
};

const validatePassword = () => {
  if (!loginForm.password) {
    passwordError.value = '密码不能为空';
    return false;
  }
  if (loginForm.password.length < 6) {
    passwordError.value = '密码长度不能少于6位';
    return false;
  }
  passwordError.value = '';
  return true;
};

const validatePhoneRegister = () => {
  const phoneRegex = /^1[3-9]\d{9}$/;
  if (!registerForm.phoneNumber) {
    phoneError.value = '手机号不能为空';
    return false;
  }
  if (!phoneRegex.test(registerForm.phoneNumber)) {
    phoneError.value = '手机号格式不正确';
    return false;
  }
  phoneError.value = '';
  return true;
};

const validatePasswordRegister = () => {
  if (!registerForm.password) {
    passwordError.value = '密码不能为空';
    return false;
  }
  if (registerForm.password.length < 6) {
    passwordError.value = '密码长度不能少于6位';
    return false;
  }
  passwordError.value = '';
  return true;
};


const validatePassword2 = () =>{
  if (!registerForm.confirmPassword) {
    passwordError.value = '密码不能为空';
    return false;
  }
  if (registerForm.confirmPassword !== registerForm.password) {
    passwordError2.value = '两次密码输入不一样';
    return false;
  }
  passwordError2.value = '';
  return true;
}

// 登录逻辑
const handleLogin = () => {
  if (!loginForm.username || !loginForm.password) {
    alert('账号和密码不能为空');
    return;
  }
  login();

};

const login = async () => {
  try {
    const data = await homeApi.login(loginForm);

    // 保存用户信息
    authData.token = data.token;
    authData.userId = data.userId;
    authData.userInfo = loginForm;
    authData.userFlag = data.userFlag;
    authStore.setAuthData(authData);

    ElMessage.success("登录成功！")
    console.log("登录成功："+data+"用户类型："+data.userFlag);
    location.reload()
    // 通知父组件登录成功
    emit('update:visible', false) // 关闭弹窗

  }catch (error) {
    console.error(error);
  }
}

// 注册逻辑
const handleRegister = () => {
  if(!registerForm.phoneNumber || !registerForm.password) {
    alert("手机号和密码不能为空")
    return
  }else if(!registerForm.userFlag){
    alert("请选择注册用户类型")
    return
  }
  register();
};
const register = async () => {
  try {

    const data = await homeApi.register({
        phonenumber : registerForm.phoneNumber,
        password : registerForm.password,
        userFlag : registerForm.userFlag,

    });

    loginForm.username = registerForm.phoneNumber;

    ElMessage.success("注册成功！")
    console.log(data);
    switchTab('login')

  }catch(error) {
    console.log(error);
  }
}

const getImage = async () => {
  try {
    const data = await homeApi.captchaImage();

    registerForm.captcha = "data:image/png;base64,"+data.img;
    uuid.value = data.uuid

    console.log(registerForm.captcha);

  }catch(error) {
    console.log(error);
  }
}

onMounted(() =>{

  // if (authStore.isLoggedIn === false) {
  //   getImage();
  // }
  getImage();

})
</script>

<style scoped>
.auth-modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 50%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}

.modal-content {
  background: #fff;
  width: 100%;
  //padding: 20px;
  //border-radius: 8px;
  //box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.modal-header {
  display: flex;
  justify-content: space-around;
  margin-bottom: 20px;
}

.modal-header h2 {
  font-size: 18px;
  color: #999;
  padding-bottom: 10px;
  cursor: pointer;
}

.modal-header h2.active {
  color: #000;
  font-weight: bold;
  border-bottom: 2px solid #007bff;
}
.form-group{
  margin-bottom: 20px;
  padding: 0 15px;
  text-align: left;

  label {
    display: block;
    margin-bottom: 5px;
    font-weight: 500;
    text-align: left;
  }

  input {
    width: 100%;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 16px;
  }

  input:focus {
    border-color: #409eff;
    outline: none;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
  }
  .error-message {
    color: #f56c6c;
    font-size: 12px;
    margin-top: 5px;
    text-align: left;
  }

  .captcha {
    cursor: pointer;
    margin-left: 15px;
  }

}

button {
  width: 100%;
  padding: 10px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 20px;
}

.btn-disabled {
  background-color: #c0c4cc !important; /* 灰色 */
  cursor: not-allowed;
}

.footer {
  text-align: center;
  margin-top: 20px;
  color: #999;
}
</style>
